<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card>
                    <div class="card-title" style="display: inline-flex;">
                        <b-button @click="$emit('back')" size="sm">Back</b-button>
                        <span class="ms-2 pt-1">View Document</span>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row >
            <b-col cols="8">
                <div class="card bg-dark">
                    <annotate-pdf
                    v-if="b64 != null && show_document"
                    :sign_mode="false"
                    @progress="setProgress"
                    :base64="b64"/>
                    <b-alert v-else show>{{message}}</b-alert>
                </div>
            </b-col>

            <b-col cols="4">
                <b-card>
                    <b-button size="lg" @click="$bvModal.show('notesModal');" variant="outline-success">
                        <i class="fas fa-comment"></i>
                    </b-button>
                    &nbsp;
                    <b-button size="lg" variant="outline-success">
                        <i class="fas fa-envelope"></i>
                    </b-button>
                </b-card>

                <b-card title="SOP Info">
                    <div v-if="revision_data != null">
                        <p>
                            <strong>SOP Code:</strong>&nbsp;
                            {{revision_data.client_sop_code}}
                        </p>
                        <p>
                            <strong>SOP Group:</strong>&nbsp;
                            --
                        </p>
                        <p>
                            <strong>SOP Name:</strong>&nbsp;
                            {{revision_data.client_sop_name}}
                        </p>
                        <p>
                            <strong>Revision No:</strong>&nbsp;
                            {{revision_data.client_revision_no}}
                        </p>
                        <p>
                            <strong>Date Released:</strong>&nbsp;
                            {{revision_data.effective_date}}
                        </p>
                    </div>
                </b-card>
                <!-- ************ -->
                <b-card title="Notes">

                </b-card>
                <!-- ************ -->
                <b-card v-if="is_actionable_view">
                    <b-row>
                        <b-col cols="12">
                            <b-button variant="primary" size="lg" @click="readDoc" >
                                Approve</b-button>
                            &nbsp;
                            <b-button variant="danger" size="lg" @click="flagDoc">
                                Reject</b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-modal hide-footer title="Comment" id="notesModal">
            <div class="modal-body">
                <b-form>
                    <b-form-group class="mb-4" label="Comment: " label-for="comment" label-cols-sm="3">
                        <b-form-input
                            id="comment"
                            type="text"
                            v-model="new_comment_text"
                        ></b-form-input>
                    </b-form-group>
                </b-form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary">Save</button>
                <button type="button" class="btn btn-secondary">Close</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import _ from 'lodash';
import { sopClientAdminState, sopClientAdminMethods, layoutMethods} from '@/state/helpers.js'
export default {
    data:() => ({
        b64: null,
        message: 'Waiting for document data',
        show_document: null,
        revision_data: null,
        scroll_progress: 0,
        document_load_error: false,
        new_comment_text: '',
    }),
    components:{
        
    },
    props:{
        //* show the 'Read' and 'Flag' buttons if true
        is_actionable_view:{
            default: false
        },
        view_id:{
            default: null,
        }
    },
    computed:{
        ...sopClientAdminState,
        sop_revisions(){
            if(this.sop_data != null){
                return this.sop_data.client_revisions;
            }
            else{
                return [];
            }
        },
    },
    methods:{
        ...layoutMethods,
        ...sopClientAdminMethods,
        findPublishedRevision(){
            console.log('SOP REVISIONS: ', this.sop_revisions);
            let index = _.findIndex(this.sop_revisions, {published: 1});
            console.log('Index: ', index)
            if(index != -1){
                this.selectRevision(index);
            }
            if(index == -1){
                this.document_load_error = true;
            }
        },
        findPublishedRevisionForID(id){
            console.log('ID ',id);
            this.findPublishedRevision();
        },
        selectRevision(index){
            this.revision_data = _.cloneDeep(this.sop_revisions[index]);
            this.selected_revision_index = index;

            //Load pdf b64 of latest revision
            this.b64 = null;
            this.getPreviewB64(this.revision_data.client_revision_id)
            .then( data => {
                if(data.pdf_64 != undefined){
                    this.b64 = data.pdf_64;
                    this.show_document = true;
                    //let element = document.getElementById('pdfScrollBar');
                    //element.addEventListener('scroll', this.handleScrollEvent)
                }
            })
        },
        setProgress(progress){
            if(progress > this.scroll_progress){
                this.scroll_progress = progress;
            }
        },
        flagDoc(){
            let params = {
                "actionable_id":"1",
                "complete":false,
                "flagged":true,
                "notes":null
            }
            this.setDocumentFlag(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'red',
                    icon: 'error',
                    title:'Flagged document.',
                    customClass: {     popup: 'warning-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                });
            })
        },
        readDoc(){
            let params = {
                "actionable_id":"1",
                "complete":true,
                "flagged":false,
                "notes":null
            }
            this.setDocumentFlag(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Marked as read.',
                    customClass: {     popup: 'success-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                });
                
            })
        }
        
        /*handleScrollEvent(){

        }*/
    },
    mounted(){
        if(this.is_actionable_view == true){
            this.findPublishedRevisionForID(this.view_id);
        }
        else{
            this.findPublishedRevision();
        }
    },
}
</script>

<style>

</style>